export const propertyTypeOptions = [
  { eligible: true, label: "Single Family", value: "Single Family" },
  { eligible: false, label: "Two Family", value: "Two Family" },
  { eligible: false, label: "Three Family", value: "Three Family" },
  { eligible: false, label: "Four Family", value: "Four Family" },
  { eligible: false, label: "Church", value: "Church" },
  { eligible: false, label: "Commercial Residential", value: "Commercial Residential" },
  { eligible: false, label: "Condominium Hotel", value: "Condominium Hotel" },
  { eligible: false, label: "Commercial Non Residential", value: "Commercial Non Residential" },
  { eligible: false, label: "Condo", value: "Condo" },
  { eligible: true, label: "Site Condo", value: "Site Condo" },
  { eligible: false, label: "Co-Op", value: "Co-Op" },
  { eligible: false, label: "Farm", value: "Farm" },
  { eligible: false, label: "High Rise", value: "High Rise" },
  { eligible: false, label: "Low Rise", value: "Low Rise" },
  { eligible: false, label: "Land And Lots", value: "Land And Lots" },
  { eligible: false, label: "Manufactured", value: "Manufactured" },
  { eligible: false, label: "Manufactured Single Wide", value: "Manufactured Single Wide" },
  { eligible: false, label: "Manufactured Multi Wide", value: "Manufactured Multi Wide" },
  { eligible: false, label: "Mobile Home", value: "Mobile Home" },
  { eligible: false, label: "Modular", value: "Modular" },
  { eligible: false, label: "Townhouse/Rowhouse", value:"Townhouse/Rowhouse" }
];

export const transactionTypeOptions = [
  { eligible: true, label: "Purchase", value: "Purchase", ltvMax: 80, purchaseAgreementRequired: true },
  { eligible: true, label: "Refinance", value: "Refinance", ltvMax: 80 },
  { eligible: false, label: "Other", value: "Other" },
];

export const contactRoleOptions = [
  { label: "Spouse", value: "Spouse" },
  { label: "Relative", value: "Relative" },
  { label: "Tenant", value: "Tenant" },
  { label: "Property Manager", value: "Property Manager" },
  { label: "Other", value: "Other" },
];

export const commercialContactRoleOptions = [
  { label: "Insured", value: "Insured" },
  { label: "Tenant", value: "Tenant" },
  { label: "Manager", value: "Manager" },
  { label: "Property Manager", value: "Property Manager" },
  { label: "Other", value: "Other" },
];

export const businessTypeOptions = [
  { label: "New Business", value: "N" },
  { label: "Renewal", value: "R" }
];

export const occupancyOptions = [
  { label: "Owner", value: "Owner" },
  { label: "Tenant", value: "Tenant" },
  { label: "Vacant", value: "Vacant" },
  { label: "Other", value: "Other" },
  { label: "Unknown", value: "Unknown" }
];

export const yesNoOptions = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];